module.exports = __webpack_public_path__ + "static/media/zon.67e97db4.png";